// src/components/modals/EmailVerificationModal.jsx
import React from 'react';
import '../../styles/components/modals.css';
import useModalHistory from '../../hooks/useModalHistory';

const EmailVerificationModal = ({ isOpen, onClose }) => {
      useModalHistory(isOpen, onClose, 'email-verification-modal');

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Verification Email Sent</h5>
          <button type="button" className="close-button" onClick={onClose}>×</button>
        </div>
        <div className="modal-body">
          <p>
            A verification email has been sent to your registered email address. 
            Please check your inbox and follow the instructions to complete your registration.
          </p>
        </div>
        <div className="modal-footer">
          <button type="button" className="close-button-footer" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default EmailVerificationModal;